import cx from 'classnames'
import Link from 'next/link'
import { PropsWithChildren } from 'react'
import RightIcon from '../icons/right'
import s from './styles.module.css'

interface SectionProps {
  title: string
  titleLocation?: 'left' | 'center' | 'right'
  slug?: string
  className?: string
}

export default function Section({
  title,
  titleLocation = 'left',
  slug,
  children,
  className,
}: PropsWithChildren<SectionProps>) {
  return (
    <div className={className}>
      <div className={s.sectionWrapper}>
        <div
          className={cx(s.sectionLabel, {
            [s.center]: titleLocation === 'center',
          })}>
          {titleLocation !== 'left' && <span className={s.sectionLine}></span>}
          <span className={s.title}>{title}</span>
          {titleLocation !== 'right' && (
            <span
              className={cx(s.sectionLine, {
                [s.colSpan2]: titleLocation === 'left' && !slug,
              })}></span>
          )}
          {slug && (
            <Link href={slug} className={cx(s.link)}>
              <span>View All</span> <RightIcon />{' '}
            </Link>
          )}
        </div>
        {children}
      </div>
    </div>
  )
}
